export const entityCacheOptions = {
  staleTime: Infinity,
  gcTime: Infinity
}
